const FlavorListLoading = () => (
    <div className={"mt-[30px]"}>
      <div className="animate-pulse flex space-x-4 w-full">
        <div className="flex-1 space-y-6 py-1">
          <div className="space-y-3">
            <div className="grid grid-cols-5 gap-4">
              <div className="h-4 bg-gray-300 rounded col-span-4"></div>
            </div>
            <div className="grid grid-cols-5 gap-4">
              <div className="h-6 bg-gray-200 rounded-full col-span-1"></div>
              <div className="h-6 bg-gray-200 rounded-full col-span-1"></div>
              <div className="h-6 bg-gray-200 rounded-full col-span-1"></div>
              <div className="h-6 bg-gray-200 rounded-full col-span-1"></div>
              <div className="h-6 bg-gray-200 rounded-full col-span-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
)

export default FlavorListLoading
